import { cloneDeep } from 'lodash';
const INITIALIZE_STORE = 'INITIALIZE_STORE';

const initialState = {
	id: null,
	type: null,
	about_us: null,
	braintree_phone_number: null,
	contact_url: null,
	facebook_link: null,
	font_path: null,
	from_email: null,
	full_name: null,
	gtm_id: null,
	hiw_subtitle: null,
	logo: null,
	member_services_email: null,
	member_services_url: null,
	member_services_phone: null,
	name: null,
	one_credit: null,
	preorder_price: null,
	regular_book_price: null,
	second_book: null,
	two_credits: null,
	tla: null,
	third_book: null,
	twitter_link: null,
	url: null
};

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case INITIALIZE_STORE:
			return {...action.payload};
		default:
			return state;
	}
}

export function storeInitialize(store, visibleGenre, visibleCategory, giftShop=[] ){
	return{
		type: INITIALIZE_STORE,
		payload: { ...store, visibleGenre, visibleCategory, giftShop }
	}
}


// WEBPACK FOOTER //
// ./src/modules/store.js